export default __webpack_public_path__ + "static/media/save.d376c30b.png";